"use client";

import {
  Button,
  EmptyState,
  ErrorState,
  Skeleton,
  SkeletonText,
  SkeletonRow,
} from "@aio/platform-ui";
import { Inbox } from "lucide-react";

export default function StatesPage() {
  return (
    <div className="space-y-10">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">States</h1>
        <p className="mt-1 text-fg-muted">Empty, loading, and error states the platform always uses.</p>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Empty</h2>
        <EmptyState
          icon={<Inbox aria-hidden="true" />}
          title="No invoices yet"
          description="When you create your first invoice it will appear here."
          action={<Button>Create invoice</Button>}
        />
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Loading skeletons</h2>
        <div className="space-y-3">
          <SkeletonText lines={4} />
          <div className="rounded-md border border-border">
            {Array.from({ length: 5 }).map((_, i) => (
              <SkeletonRow key={i} />
            ))}
          </div>
          <div className="flex gap-3">
            <Skeleton className="size-12 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          </div>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Error</h2>
        <ErrorState
          title="Could not load invoices"
          description="The accounting service is unreachable. Try again."
          traceId="t-9f3a-2b1c"
          onRetry={() => alert("retry clicked")}
        />
      </section>
    </div>
  );
}
